<div class="payment-container mt-5" id="order-payment" *ngIf="hasPayment">
  <app-company-invoice
    *ngIf="showPaymentButtons"
    [orderId]="orderId"
  />

  <p *ngIf="showPaymentButtons" class="payment-subtitle">{{ "PAYMENT.SELECT_PAYMENT_METHOD" | translate }}</p>

  <div class="payment-way-container" *ngIf="showPaymentButtons">
    <div class="payment-way-content">
      <ng-container *ngFor="let paymentWay of paymentWays">
        <button
          (click)="(paymentWay.name && (cardType !== 'kekspay' || paymentWay.name !== 'kekspay') && (cardType !== 'aircashpay' || paymentWay.name !== 'aircashpay')) && selectCardTypeForPayment(paymentWay.name)" class="payment-way-item"
          [ngClass]="{ 'active': cardType === paymentWay.name }"
          >
          <div class="payment-way-img-container" *ngIf="paymentWay.name !== 'temp_nacpl'">
            <img src="img/payment/{{paymentWay.name}}.svg" />
          </div>

          <div class="payment-way-img-container" *ngIf="paymentWay.name === 'temp_nacpl'">
            <img src="img/payment/visa.png" />
            <img src="img/payment/mastercard.png" />
            <img src="img/payment/maestro.png" />
            <img src="img/payment/diners.png" />
          </div>
        </button>
      </ng-container>

      <button
        (click)="selectCardTypeForPayment('saved-cards')"
        class="payment-way-item"
        [ngClass]="{ 'active': cardType === 'saved-cards' }"
        *ngIf="userCards.length > 0"
        >
        <p class="payment-way-img-container saved-cards-button">{{ "PAYMENT.SAVED_CARDS" | translate }}</p>
      </button>

      <div *ngIf="cardType !== 'aircashpay' && cardType !== 'kekspay'" class="w-100">
        <form [formGroup]="saveCardForm" *ngIf="cardType === 'temp_nacpl' && !userCardToken">
          <label for="saveCardYes" class="ml-1">
            <div class="container-checkbox mt-5">
              <input type="checkbox" id="saveCardYes" formControlName="saveCardYes" />
              <span class="checkmark"></span>
              {{ "CART.SAVE_CARD" | translate }}
            </div>
          </label>
        </form>
      </div>

      <div class="button-container">
        <div class="flex">
          <ng-container *ngIf="cart">
            <!-- <button
              class="btn btn-default mr-4"
              (click)="goBack()"
              *ngIf="!cart.transactionInfo?.isLocked && !cart.transactionInfo?.ticketDelagation && cart.items?.length === 0"
              >{{ "COMMON.BACK" | translate }}
            </button> -->
          </ng-container>

          <button
            class="btn btn-default"
            (click)="cancelOrder()">{{ "COMMON.CANCEL" | translate }}
          </button>
        </div>

        <button
          class="btn btn-primary"
          [ngClass]="{ 'disabled': cardType === '' }"
          (click)="cardType === 'temp_nacpl' ? onSubmitMonriCardForm() : (cardType === 'saved-cards' ? openSavedCardsModal() : onSubmit())"
          [disabled]="cardType === ''"
          *ngIf="!hidePaymentButtons"
          >
          {{ "PAYMENT.PAY" | translate }}
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="redirectPage !== 'user-profile' && redirectPage !== 'group-tickets-profile'">
    <ng-container *ngTemplateOutlet="paymentContent"></ng-container>
  </ng-container>
</div>

<form ngNoForm #pgw id="pgw" name="pgw" method="post" action="{{paymentUrl}}/user/init" target="paymentIframe" *ngIf="paymentIsDone">
  <input type="hidden" name="lang" [value]="paymentLanguage()"/>
  <input type="hidden" name="opis" value="{{customerProfile.firstName}} {{customerProfile.lastName}}" />
  <input type="hidden" name="trg_id" [value]="connId"/>
  <input type="hidden" name="brdok" [value]="orderId"/>
  <input type="hidden" name="sifpl" [value]="paymentInfo.sifpl"/>
  <input type="hidden" name="order_description" value="tickets"/>
  <input type="hidden" name="redirect_url" [value]="redirectUrlFromParent || redirectUrl" />
  <input type="hidden" name="redirect_url_err" [value]="redirectErrorUrlFromParent || redirectUrlErr"/>
  <input type="hidden" name="appId" [value]="appId">
  <input type="hidden" name="iznos" [value]="paymentInfo.iznos"/>
  <input type="hidden" name="hash" [value]="paymentInfo.hash"/>
  <input type="hidden" name="valuta" [value]="paymentInfo.valuta"/>
  <input type="hidden" name="shipAddressCity" value=""/>
  <input type="hidden" name="shipAddressCountry" value=""/>
  <input type="hidden" name="shipAddressFirstName" value=""/>
  <input type="hidden" name="shipAddressLastName" value=""/>
  <input type="hidden" name="shipAddressPostCode" value=""/>
  <input type="hidden" name="shipAddressStreet" value=""/>
  <input type="hidden" name="shipAddressHouseNo" value=""/>
  <input type="hidden" name="isTokenRequest" [value]="saveCardValue"/>
  <input type="hidden" name="wpId" [value]="wpId"/>
  <input type="hidden" name="token" [value]="userCardToken"/>
  <input type="hidden" name="tokenNumber" [value]="userCardTokenNumber"/>
</form>

<section id="payment-modal-container" *ngIf="isPaymentModalOpen() && (redirectPage === 'user-profile' || redirectPage === 'group-tickets-profile')">
  <div class="modal modal-container" (mousedown)="modalService.closeModal(modalNamesEnum.Payment)">
    <div class="modal-content" (mousedown)="$event.stopPropagation()">
      <button type="button" class="btn-close" (click)="modalService.closeModal(modalNamesEnum.Payment)" [attr.title]="'COMMON.CLOSE' | translate">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 17 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.79287 8.6478L1 1.85493L1.70711 1.14783L8.49997 7.94069L15.2928 1.14783L15.9999 1.85493L9.20708 8.6478L15.4982 14.9389L14.7911 15.646L8.49997 9.35491L2.20887 15.646L1.50176 14.9389L7.79287 8.6478Z" fill="#797979"/>
          <path d="M1 1.85493L0.823223 1.67816C0.776339 1.72504 0.75 1.78863 0.75 1.85493C0.75 1.92124 0.776339 1.98483 0.823223 2.03171L1 1.85493ZM7.79287 8.6478L7.96964 8.82458C8.01653 8.77769 8.04287 8.7141 8.04287 8.6478C8.04287 8.5815 8.01653 8.51791 7.96964 8.47102L7.79287 8.6478ZM1.70711 1.14783L1.88388 0.97105C1.78625 0.873419 1.62796 0.873419 1.53033 0.97105L1.70711 1.14783ZM8.49997 7.94069L8.3232 8.11747C8.42083 8.2151 8.57912 8.2151 8.67675 8.11747L8.49997 7.94069ZM15.2928 1.14783L15.4696 0.97105C15.372 0.873419 15.2137 0.873419 15.1161 0.97105L15.2928 1.14783ZM15.9999 1.85493L16.1767 2.03171C16.2236 1.98483 16.2499 1.92124 16.2499 1.85493C16.2499 1.78863 16.2236 1.72504 16.1767 1.67816L15.9999 1.85493ZM9.20708 8.6478L9.0303 8.47102C8.93267 8.56865 8.93267 8.72694 9.0303 8.82458L9.20708 8.6478ZM15.4982 14.9389L15.675 15.1157C15.7726 15.0181 15.7726 14.8598 15.675 14.7621L15.4982 14.9389ZM14.7911 15.646L14.6143 15.8228C14.7119 15.9204 14.8702 15.9204 14.9679 15.8228L14.7911 15.646ZM8.49997 9.35491L8.67675 9.17813C8.57912 9.0805 8.42083 9.0805 8.3232 9.17813L8.49997 9.35491ZM2.20887 15.646L2.03209 15.8228C2.12972 15.9204 2.28801 15.9204 2.38564 15.8228L2.20887 15.646ZM1.50176 14.9389L1.32498 14.7621C1.2781 14.809 1.25176 14.8726 1.25176 14.9389C1.25176 15.0052 1.2781 15.0688 1.32498 15.1157L1.50176 14.9389ZM0.823223 2.03171L7.61609 8.82458L7.96964 8.47102L1.17678 1.67816L0.823223 2.03171ZM1.53033 0.97105L0.823223 1.67816L1.17678 2.03171L1.88388 1.3246L1.53033 0.97105ZM8.67675 7.76392L1.88388 0.97105L1.53033 1.3246L8.3232 8.11747L8.67675 7.76392ZM8.67675 8.11747L15.4696 1.3246L15.1161 0.97105L8.3232 7.76392L8.67675 8.11747ZM15.1161 1.3246L15.8232 2.03171L16.1767 1.67816L15.4696 0.97105L15.1161 1.3246ZM15.8232 1.67816L9.0303 8.47102L9.38386 8.82458L16.1767 2.03171L15.8232 1.67816ZM15.675 14.7621L9.38386 8.47102L9.0303 8.82458L15.3214 15.1157L15.675 14.7621ZM14.9679 15.8228L15.675 15.1157L15.3214 14.7621L14.6143 15.4692L14.9679 15.8228ZM8.3232 9.53168L14.6143 15.8228L14.9679 15.4692L8.67675 9.17813L8.3232 9.53168ZM8.3232 9.17813L2.03209 15.4692L2.38564 15.8228L8.67675 9.53168L8.3232 9.17813ZM2.38564 15.4692L1.67853 14.7621L1.32498 15.1157L2.03209 15.8228L2.38564 15.4692ZM1.67853 15.1157L7.96964 8.82458L7.61609 8.47102L1.32498 14.7621L1.67853 15.1157Z" fill="#797979"/>
        </svg>
      </button>

      <ng-container *ngTemplateOutlet="paymentContent"></ng-container>
    </div>
  </div>
</section>

<ng-template #paymentContent>
  <div class="w-100" *ngIf="(cardType === 'aircashpay' || cardType === 'kekspay') && paymentButtonIsClicked">
    <div class="payment-instructions" *ngIf="cardType === 'kekspay' && deviceType === 'D'">
      <div class="payment-instructions-header">
        <img src="img/payment/kekspay.svg" />
        <p class="payment-instructions-text">{{ "PAYMENT.REMAINING_TIME_TO_PAY" | translate }}: {{ remainingTimeToPayFormatted }}</p>
      </div>

      <span><b>1.</b> {{ "CART.KEKS.OPEN" | translate }}</span>
      <span class="flex"><b>2.</b>&nbsp;
        {{ "CART.KEKS.KEKS_ICON_1" | translate }}
        <img src="img/payment/keks_pay_icon.png" class="keks-icon" />
        {{ "CART.KEKS.KEKS_ICON_2" | translate }}
      </span>
      <span><b>3.</b> {{ "CART.KEKS.SCAN_AND_PAY" | translate }}</span>
      <span><b>4.</b> {{ "CART.KEKS.SCAN_QR_CODE" | translate }}</span>
      <span><b>5.</b> {{ "CART.KEKS.FOLLOW_INSTRUCTIONS" | translate }}</span>
    </div>

    <div class="payment-instructions" *ngIf="cardType === 'aircashpay' && deviceType === 'D'">
      <div class="payment-instructions-header">
        <img src="img/payment/aircashpay.svg" />
        <p class="payment-instructions-text mt-5">{{ "PAYMENT.REMAINING_TIME_TO_PAY" | translate }}: {{ remainingTimeToPayFormatted }}</p>
      </div>

      <span>1. {{ "CART.AIRCASH.OPEN" | translate }}</span>
      <span>2. {{ "CART.AIRCASH.SCAN_AND_PAY" | translate }}</span>
      <span>3. {{ "CART.AIRCASH.SCAN_QR_CODE" | translate }}</span>
      <span>4. {{ "CART.AIRCASH.FOLLOW_INSTRUCTIONS" | translate }}</span>
    </div>

    <div class="flex flex-center">
      <img src="{{qrCode}}" *ngIf="deviceType === 'D'" />
    </div>

    <!-- button (click)="openApplication()" class="button continue-button" *ngIf="deviceType === 'M' && qrLink">{{ "PAYMENT.OPEN" | translate }} {{ cardType === "kekspay" ? "KEKS Pay" : "Aircash"}}</button> -->
  </div>

  <div class="user-cards-container" id="user-cards-container" *ngIf="cardType === 'saved-cards' && showSavedCards">
    <div class="text-info w-100">
      <p class="subtitle">{{ "CART.SAVED_CARDS" | translate }}:</p>
      <p class="mt-2">{{ "CART.SELECT_SAVED_CARD" | translate }}.</p>
    </div>

    <div class="user-saved-cards-container">
      <div class="app-credit-card-container" *ngFor="let userCard of userCards">
        <button
          (click)="selectUserCard(userCard)"
          class="button-card"
          [ngClass]="{ 'active': userCardToken === userCard.token }"
          >
          <div class="app-credit-card-bg">
            <app-credit-card [card]="userCard"></app-credit-card>
          </div>
        </button>
      </div>
    </div>
  </div>

  <iframe id="paymentIframe" name="paymentIframe" style="width: 100%; min-height: 500px; display: none;"></iframe>
</ng-template>
